
<div>
  @if (showDivider) {
    <p-divider align="left" class="pt-2">
      <div class="inline-flex gap-2 align-items-center">
        <i class="pi pi-envelope"></i>
        <b>{{'MESSAGES' | translate}}</b>
      </div>
    </p-divider>
  }

  <app-loading [active]="isLoading && !pagedData" [center]="true"/>
  <app-message [active]="!!errorMsg" [message]="errorMsg"/>

  @if (!errorMsg && columns && pagedData) {
    <div id="divMatches">
      <app-generic-list class="frontend customPaging smart" [frontend]="true"

                        [columns]="columns" [columnsMobile]="columnsMobile"
                        [noDataMsg]="'TABLE_NO_DATA'"

                        [pagedData]="pagedData"
                        [pageSize]="paging.pageSize"
                        [pagingCustom]="true"
                        [rowsPerPageOption]="undefined"
                        [showFooter]="true"
                        [footerRight]="footerRightTemplate"
                        (onLazyLoading)="lazyLoading($event)"

                        [mobileRowTemplate]="mobileRowTemplate"
                        [hideMobileRowButtonsColumn]="!showDeleteSelected"
                        [rowDelete]="showDeleteSelected" (onRowDelete)="rowDelete($event)"
                        [rowSelect]="true" (onRowSelect)="onRowSelect($event)"

                        [sortable]="true"
                        [sortField]="paging.sortField"
                        [sortOrder]="paging.sortOrder"

                        [scrollable]="positionTop > 0"
                        [positionTop]="positionTop"
                        [dataLoading]="isLoading || deletingMessage"
                        [showReload]="true" (onReload)="loadData()"
      />
    </div>
  }

  <ng-template #mobileRowTemplate let-item="data" pTemplate="item">
    <td>
      <div class="flex align-items-center gap-2">
        <div>
          <div class="text-center">
            {{item.date | date: 'shortDate'}}
          </div>
          <div class="text-center">
            {{item.date | date: 'shortTime'}}
          </div>
        </div>
        <div>
          <ng-container [ngTemplateOutlet]="typeTemplate" [ngTemplateOutletContext]="{data: item}"/>
        </div>
        <div class="flex-1">
          {{item.subject}}
        </div>
        <div>
          <ng-container [ngTemplateOutlet]="linksTemplate" [ngTemplateOutletContext]="{data: item}"/>
        </div>
      </div>
    </td>
  </ng-template>

  <ng-template #footerRightTemplate pTemplate="item">
    <div class="flex align-items-center pr-2 gap-2 md:gap-3">
      <app-interactive-help [text]="'PLAYER_PROFILE_MESSAGES_AUTODELETE_INFO' | translate"
                            icon="pi pi-info-circle text-white"/>

      <div class="cursor-pointer accent-hover" (click)="showDeleteSelected = !showDeleteSelected">
        <i class="pi pi-trash" [class.accent]="showDeleteSelected"></i>
      </div>
    </div>
  </ng-template>

  <ng-template #textTemplate let-item="data" pTemplate="item">
    <div>
      {{item.subject}}
    </div>
  </ng-template>

  <ng-template #typeTemplate let-item="data" pTemplate="item">
    @if (item.typeCd === 'MAIL') {
      <i class="pi pi-at" [pTooltip]="'EMAIL' | translate" [showDelay]="400"></i>
    } @else if (item.typeCd === 'PUSH') {
      <i class="pi pi-mobile" [pTooltip]="'PUSH_NOTIFICATION' | translate" [showDelay]="400"></i>
    } @else {
      <i class="pi pi-envelope" [pTooltip]="'MESSAGE' | translate" [showDelay]="400"></i>
    }
  </ng-template>

  <ng-template #linksTemplate let-item="data" pTemplate="item">
    @if (item.link) {
      <p-button icon="pi pi-external-link" styleClass="p-button-text" (onClick)="openLink(item.link)"/>
    } @else {
      <div class="py-2">&nbsp;</div>
    }
  </ng-template>
</div>
